"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_TYPE_ROLE_MAP = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
exports.CLIENT_TYPE_ROLE_MAP = {
    [legacy_enums_1.ClientType.Website]: legacy_enums_1.CUSTOMER_INTERFACE_ROLES,
    [legacy_enums_1.ClientType.iOS]: legacy_enums_1.CUSTOMER_INTERFACE_ROLES,
    [legacy_enums_1.ClientType.CustomerApp]: legacy_enums_1.CUSTOMER_INTERFACE_ROLES,
};
//# sourceMappingURL=appRoles.js.map